import NotFoundPage from "@/views/NotFound";

export default [
    {
        path: '/:pathMatch(.*)*',
        component: NotFoundPage,
        name: 'NotFound',
        meta: {
            requiresAuth: false
        }
    },
];
